import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

/**
 * The mark: a compass needle that is also a play arrow.
 *
 * Two shapes and a ring, nothing else. It has to read at 20px in a toolbar and as a favicon,
 * and every extra stroke is invisible at that size while still costing contrast — a logo that
 * only works at 200px is a logo the product never actually shows.
 *
 * Drawn in `currentColor` rather than in fixed colours so it inherits the theme: the same file
 * is right in light mode, in dark mode and on a coloured surface.
 */
export function Logo(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" strokeWidth="1.6" />
      {/* South half of the needle: the way you came. */}
      <path d="M12 12 L7.2 16.8 L10.1 10.1 Z" fill="currentColor" opacity="0.35" />
      {/* North half: the way to go, and the shape of a play button. */}
      <path d="M12 12 L16.8 7.2 L13.9 13.9 Z" fill="currentColor" />
    </SvgIcon>
  );
}
